"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./pathwayTitleBlock.scss");
const CollectionTitleDescBlockLoader_1 = __importDefault(require("../../collection/CollectionTitleDescBlock/collectionTitleDescBlockLoaders/CollectionTitleDescBlockLoader"));
function PathwayTitleBlock(props) {
    return props.loading ? (react_1.default.createElement(CollectionTitleDescBlockLoader_1.default, Object.assign({}, props, { isMobile: false }))) : (react_1.default.createElement("div", { id: "collection-title-desc-block" },
        react_1.default.createElement("span", { className: "collection-title" }, props.title)));
}
exports.default = PathwayTitleBlock;
